import React, { useEffect, useState } from 'react';
import { Modal, Toast } from 'antd-mobile';
import { isEmpty } from 'lodash';
import { Clickable } from '@/components';
import { formatDate } from '@/utils/utils';
import check from '@/assets/images/circled-check.svg';
import noPrize from '@/assets/images/no-prize.svg';
import MemberRewardModal from '../MemberRewardModal';

export const queryMemberRewards = async ({
  qryUserRewardListDXP,
  saveMemData,
  membershipTypeCode,
  rewardState,
}) => {
  await qryUserRewardListDXP({ membershipTypeCode }).then(res => {
    if (res && res?.data?.rewardList?.length > 0) {
      const listTmp = res?.data?.rewardList;
      saveMemData({
        myMemRewardsList: rewardState
          ? listTmp.filter(item => item?.state === rewardState)
          : listTmp,
      });
    }
  });
};

export const claimMemberReward = ({
  claminMemRewardDXP,
  rewardInfo,
  selectedReward,
  GCPI18n,
  onSuccess,
}) => {
  claminMemRewardDXP({
    rewardInstanceId: rewardInfo?.rewardInstanceId || selectedReward?.rewardInstanceId,
  }).then(res => {
    if (res?.retCode === '0') {
      onSuccess();
    } else {
      Toast.show({
        icon: 'fail',
        content: res?.retDesc || GCPI18n({ id: 'lb_medal_msg_claim_fail' }),
      });
    }
  });
};

export const useMemberRewardActions = ({
  qryUserRewardListDXP,
  saveMemData,
  claminMemRewardDXP,
  membershipTypeCode,
  GCPI18n,
  onBeforeClaim,
  onClaimSuccess,
}) => {
  const [state, setState] = useState('');
  const [selectedReward, setSelectedReward] = useState({});
  const [rewardPopVisible, setRewardPopVisible] = useState(false);
  const [rewardGotPopVisible, setRewardGotPopVisible] = useState(false);

  const qryMyRewardsList = async rewardState => {
    await queryMemberRewards({
      qryUserRewardListDXP,
      saveMemData,
      membershipTypeCode,
      rewardState,
    });
  };

  const handleClaimReward = (toMobileNumber, rewardInfo) => {
    claimMemberReward({
      claminMemRewardDXP,
      rewardInfo,
      selectedReward,
      GCPI18n,
      onSuccess: () => {
        qryMyRewardsList();
        onClaimSuccess?.();
      },
    });
  };

  const handleClickClaimButton = rewardObj => {
    onBeforeClaim?.();
    setSelectedReward(rewardObj);
    handleClaimReward('', rewardObj);
  };

  const handleChangeState = val => {
    setState(val);
    qryMyRewardsList(val);
  };

  useEffect(() => {
    qryMyRewardsList();
  }, []);

  return {
    state,
    selectedReward,
    rewardPopVisible,
    rewardGotPopVisible,
    handleChangeState,
    handleClaimReward,
    handleClickClaimButton,
    closeRewardPop: () => setRewardPopVisible(false),
    closeRewardGotPop: () => setRewardGotPopVisible(false),
  };
};

export const createMemberRewardsDispatchProps = dispatch => ({
  saveMemData: payload =>
    dispatch({
      type: 'memberShipCenter/save',
      payload,
    }),
  qryUserRewardListDXP: payload =>
    dispatch({
      type: 'memberShipCenter/qryUserRewardListDXP',
      payload,
    }),
  claminMemRewardDXP: payload =>
    dispatch({
      type: 'memberShipCenter/claminMemRewardDXP',
      payload,
    }),
});

export const memberRewardsStateToProps = ({ memberShipCenter, index }) => ({
  myMemRewardsList: memberShipCenter.myMemRewardsList,
  activityDetail: index.activityDetail,
  product: index.product,
  userDimension: index.userDimension,
});

export const RewardStateTabs = ({ styles, classnames, state, GCPI18n, onChange, hidden }) => (
  <div className={styles.buttonList} style={hidden ? { display: 'none' } : undefined}>
    {[
      ['', 'lb_titile_list_past'],
      ['A', 'lb_mian_reward_unclaimed'],
      ['B', 'lb_chanllenge_claimed'],
    ].map(([value, labelId]) => (
      <Clickable
        key={value || 'all'}
        className={classnames(styles.buttonItem, state === value ? styles.highLight : '')}
        onClick={() => onChange(value)}
      >
        {GCPI18n({ id: labelId })}
        <div className={state === value ? styles.highLightBottom : ''} />
      </Clickable>
    ))}
  </div>
);

export const RewardStatus = ({ styles, item, GCPI18n, onClaim }) => {
  if (item.state === 'E') {
    return <div className={styles.expired}>{GCPI18n({ id: 'lb_chanllenge_expired' })}</div>;
  }
  return item.state === 'A' ? (
    <Clickable className={styles.claimButton} onClick={() => onClaim(item)}>
      {GCPI18n({ id: 'lb_chanllenge_claim' })}
    </Clickable>
  ) : (
    <div className={styles.claimed}>
      <div className={styles.imgBox}>
        <img src={check} alt="" />
      </div>
      <div className={styles.claimedMessage}>{GCPI18n({ id: 'lb_chanllenge_claimed' })}</div>
    </div>
  );
};

export const RewardSummary = ({ styles, item, GCPI18n, onClick, className, right }) => (
  <div className={className}>
    <Clickable className={styles.left} onClick={() => onClick(item)}>
      <div className={styles.imgBox}>
        <img src={item.imageUrl} alt="" />
      </div>
      <div className={styles.rewardInfo}>
        <div className={styles.rewardName}>{item?.rewardMemName || item?.rewardName}</div>
        <div className={styles.rewardExpText}>
          {`${
            item?.state === 'B'
              ? GCPI18n({ id: 'lb_main_claimed_at' })
              : GCPI18n({ id: 'lb_main_rewarded_at' })
          }:`}
        </div>
        <div className={styles.rewardExpDate}>{formatDate(item?.stateDate)}</div>
      </div>
    </Clickable>
    <div className={styles.right}>{right}</div>
  </div>
);

export const RewardList = ({ styles, rewards, GCPI18n, onGoDetail, onClaim }) => {
  if (!rewards || isEmpty(rewards)) {
    return (
      <div className={styles.emptyPrizeContain}>
        <div className={styles.imgBox}>
          <img src={noPrize} alt="" />
        </div>
        <div className={styles.noPrize}>{GCPI18n({ id: 'lb_mian_no_prizes_here' })}</div>
        <div className={styles.noPrizeMessage}>{GCPI18n({ id: 'lb_mian_claimed_no_prizes' })}</div>
      </div>
    );
  }

  return (
    <ul>
      {(rewards || []).map(item => (
        <li key={item.keyId}>
          <RewardSummary
            styles={styles}
            item={item}
            GCPI18n={GCPI18n}
            onClick={onGoDetail}
            className={styles.rewardContain}
            right={<RewardStatus styles={styles} item={item} GCPI18n={GCPI18n} onClaim={onClaim} />}
          />
        </li>
      ))}
    </ul>
  );
};

export const MemberRewardListSection = ({ styles, rewards, GCPI18n, onGoDetail, onClaim }) => (
  <div className={styles.container}>
    <RewardList
      styles={styles}
      rewards={rewards}
      GCPI18n={GCPI18n}
      onGoDetail={onGoDetail}
      onClaim={onClaim}
    />
  </div>
);

export const ClaimedRewardModal = ({
  styles,
  visible,
  image,
  GCPI18n,
  onClose,
  bodyClassName,
  showLuckyMessage,
}) => (
  <Modal
    bodyClassName={bodyClassName || `transparentModalWrap ${styles.claimedModal}`}
    visible={visible}
    closeOnMaskClick={false}
  >
    <div className={styles.claimedContain}>
      <div className={styles.tipImg}>
        <img src={image} alt="" />
      </div>
      <div className={styles.congratulationMessage}>
        {GCPI18n({ id: 'lb_mian_claimed_success' })}
      </div>
      {showLuckyMessage && (
        <div className={styles.luckyMessage}>
          {GCPI18n({ id: 'lb_mian_claimed_success_message' })}
        </div>
      )}
      <Clickable className={styles.okButton} onClick={onClose}>
        {GCPI18n({ id: 'lb_reduce_success_btn' })}
      </Clickable>
    </div>
  </Modal>
);

export const MemberRewardDialogs = ({
  rewardPopVisible,
  rewardGotPopVisible,
  selectedReward,
  handleClaimReward,
  closeRewardPop,
  closeRewardGotPop,
}) => (
  <>
    {rewardPopVisible && (
      <MemberRewardModal
        isNeedNumberPop={rewardPopVisible}
        onOk={handleClaimReward}
        onClose={closeRewardPop}
      />
    )}
    {rewardGotPopVisible && (
      <MemberRewardModal
        isNeedGotPop={rewardGotPopVisible}
        onClose={closeRewardGotPop}
        claminReward={selectedReward}
      />
    )}
  </>
);

export const MemberRewardsContent = ({
  styles,
  rewards,
  GCPI18n,
  onGoDetail,
  onClaim,
  showClaimedModal,
  claimedImage,
  onCloseClaimed,
  claimedBodyClassName,
  showLuckyMessage,
  extra,
}) => (
  <>
    <MemberRewardListSection
      styles={styles}
      rewards={rewards}
      GCPI18n={GCPI18n}
      onGoDetail={onGoDetail}
      onClaim={onClaim}
    />
    {showClaimedModal && (
      <ClaimedRewardModal
        styles={styles}
        visible={showClaimedModal}
        image={claimedImage}
        GCPI18n={GCPI18n}
        onClose={onCloseClaimed}
        bodyClassName={claimedBodyClassName}
        showLuckyMessage={showLuckyMessage}
      />
    )}
    {extra}
  </>
);
